export function getCustomerTypeEndpoint(): string {
    return '/customer-type';
}
